var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAreaVerde03({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 80",
    style: {
      enableBackground: "new 0 0 120 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#72BA51;}\n\t.st1{fill:#75BB61;}\n\t.st2{fill:#E18852;}\n\t.st3{fill:#D36D3D;}\n\t.st4{fill:#85CE64;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_304",
    transform: "translate(23.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108",
    className: "st0",
    d: "M69,59c4.4,5,12.1,5.4,17.1,1c3.6-3.2,5-8.2,3.5-12.9c5.8-3.4,7.8-10.8,4.4-16.6 c-1.2-2.1-2.9-3.7-5-4.8c2.8-3.5,2.3-8.7-1.2-11.5c-2.6-2.1-6.2-2.4-9.1-0.9C74.5,6.3,65.1,4,58,8.3c-3,1.8-5.4,4.8-6.5,8.1 c-2.5-1.1-5.4,0-6.5,2.5c-0.6,1.4-0.5,3.1,0.2,4.5c-6.5,1.8-10.3,8.4-8.4,14.9c0.5,1.9,1.5,3.7,2.9,5.2c-1.6,8,3.6,15.8,11.6,17.3 c2.6,0.5,5.4,0.3,7.9-0.6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_295",
    transform: "translate(31.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_109",
    className: "st1",
    d: "M13.1,47.7c0-1,0.1-1.9,0.3-2.9c-4.7-4.9-4.5-12.5,0.3-17.1c1.4-1.4,3.2-2.4,5.1-2.9 c-1.4-2.4-0.5-5.4,1.7-6.7c1.4-0.8,3-0.9,4.5-0.2c1.5-9.2,9.4-11.4,14.4-10.4c0.2,0,0.4,0,0.5,0c-7.8-3.1-16.6,0.8-19.6,8.6 c-0.1,0.2-0.2,0.5-0.2,0.8c-2.5-1.1-5.4,0-6.5,2.5c-0.6,1.4-0.5,3.1,0.2,4.5c-6.5,1.8-10.3,8.4-8.4,14.9c0.5,1.9,1.5,3.7,2.9,5.2 c-1.6,8,3.6,15.8,11.6,17.3c0.8,0.1,1.5,0.2,2.4,0.3C16.8,59.1,13.1,53.7,13.1,47.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_110",
    className: "st2",
    d: "M76.9,72.9H52c3.9,0,7-2.6,7.3-6c0.8-11.7-4.1-26.1-4.1-26.1c2.2,1.6,4.1,3.6,5.7,5.8 c1,1.3,1.7,2.6,2.5,4c0,0,1.7-10.3,8-15.7c0,0-3.8,17.3-1.7,32.3C70.1,70.4,73.3,72.9,76.9,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111",
    className: "st3",
    d: "M63.1,72.9H52c3.9,0,7-2.6,7.3-6c0.8-11.7-4.1-26.1-4.1-26.1c2.2,1.6,4.1,3.6,5.7,5.8 C62.6,53.9,64.1,64.4,63.1,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_112",
    className: "st4",
    d: "M55.6,27.8c-0.5,0-1-0.4-1-1l0,0c0-4,3.2-7.3,7.3-7.3c0.5,0,1,0.4,1,1.1c0,0.5-0.4,1-1,1 c-2.9,0-5.2,2.4-5.2,5.2C56.6,27.4,56.1,27.8,55.6,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_113",
    className: "st4",
    d: "M76.8,25.6c-0.5,0-1-0.4-1-1l0,0c0-2.9-2.4-5.2-5.2-5.2c-2.9,0-5.2,2.4-5.2,5.2 c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1c0-4,3.2-7.3,7.3-7.3s7.3,3.2,7.3,7.3C77.9,25.1,77.4,25.6,76.8,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_114",
    className: "st4",
    d: "M82,73.9H48c-0.5,0-1-0.4-1-1.1c0-0.5,0.4-1,1-1h34c0.5,0,1,0.4,1,1 C83.1,73.4,82.7,73.9,82,73.9L82,73.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_302",
    transform: "translate(-31.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108-2_1_",
    className: "st0",
    d: "M64.5,59c4.4,5,12.1,5.4,17.1,1c3.6-3.2,5-8.2,3.5-12.9c5.8-3.4,7.8-10.8,4.4-16.6 c-1.2-2.1-2.9-3.7-5-4.8c2.8-3.5,2.3-8.7-1.2-11.5c-2.6-2.1-6.2-2.4-9.1-0.9C69.9,6.3,60.6,4,53.4,8.3c-3,1.8-5.4,4.8-6.5,8.1 c-2.5-1.1-5.4,0-6.5,2.5c-0.6,1.4-0.5,3.1,0.2,4.5c-6.5,1.8-10.3,8.4-8.4,14.9c0.5,1.9,1.5,3.7,2.9,5.2c-1.6,8,3.6,15.8,11.6,17.3 c2.6,0.5,5.4,0.3,7.9-0.6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_295-2_1_",
    transform: "translate(31.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_109-2_1_",
    className: "st1",
    d: "M8.6,47.7c0-1,0.1-1.9,0.3-2.9c-4.7-4.9-4.5-12.5,0.3-17.1c1.4-1.4,3.2-2.4,5.1-2.9 c-1.4-2.4-0.5-5.4,1.7-6.7c1.4-0.8,3-0.9,4.5-0.2C22.1,8.6,30,6.4,35,7.4c0.2,0,0.4,0,0.5,0C27.7,4.2,19,8.1,15.9,15.9 c-0.1,0.2-0.2,0.5-0.2,0.8c-2.5-1.1-5.4,0-6.5,2.5c-0.6,1.4-0.5,3.1,0.2,4.5C2.9,25.6-0.8,32.2,1,38.7c0.5,1.9,1.5,3.7,2.9,5.2 c-1.6,8,3.6,15.8,11.6,17.3c0.8,0.1,1.5,0.2,2.4,0.3C12.3,59.1,8.6,53.7,8.6,47.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_110-2_1_",
    className: "st2",
    d: "M72.4,72.9H47.5c3.9,0,7-2.6,7.3-6c0.8-11.7-4.1-26.1-4.1-26.1c2.2,1.6,4.1,3.6,5.7,5.8 c1,1.3,1.7,2.6,2.5,4c0,0,1.7-10.3,8-15.7c0,0-3.8,17.3-1.7,32.3C65.6,70.4,68.7,72.9,72.4,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111-2_1_",
    className: "st3",
    d: "M58.5,72.9h-11c3.9,0,7-2.6,7.3-6c0.8-11.7-4.1-26.1-4.1-26.1c2.2,1.6,4.1,3.6,5.7,5.8 C58.1,53.9,59.5,64.4,58.5,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_112-2_1_",
    className: "st4",
    d: "M51,27.8c-0.5,0-1-0.4-1-1l0,0c0-4,3.2-7.3,7.3-7.3c0.5,0,1,0.4,1,1.1c0,0.5-0.4,1-1,1 c-2.9,0-5.2,2.4-5.2,5.2C52,27.4,51.6,27.8,51,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_113-2_1_",
    className: "st4",
    d: "M72.3,25.6c-0.5,0-1-0.4-1-1l0,0c0-2.9-2.4-5.2-5.2-5.2c-2.9,0-5.2,2.4-5.2,5.2 c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1c0-4,3.2-7.3,7.3-7.3c4,0,7.3,3.2,7.3,7.3C73.3,25.1,72.8,25.6,72.3,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_114-2_1_",
    className: "st4",
    d: "M77.5,73.9h-34c-0.5,0-1-0.4-1-1.1c0-0.5,0.4-1,1-1h34c0.5,0,1,0.4,1,1 C78.5,73.4,78.1,73.9,77.5,73.9L77.5,73.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_303",
    transform: "translate(-4.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108-3",
    className: "st4",
    d: "M66.7,59c4.4,5,12.1,5.4,17.1,1c3.6-3.2,5-8.2,3.5-12.9c5.8-3.4,7.8-10.8,4.4-16.6 c-1.2-2.1-2.9-3.7-5-4.8c2.8-3.5,2.3-8.7-1.2-11.5c-2.6-2.1-6.2-2.4-9.1-0.9C72.1,6.3,62.8,4,55.7,8.3c-3,1.8-5.4,4.8-6.5,8.1 c-2.5-1.1-5.4,0-6.5,2.5c-0.6,1.4-0.5,3.1,0.2,4.5c-6.5,1.8-10.3,8.4-8.4,14.9c0.5,1.9,1.5,3.7,2.9,5.2c-1.6,8,3.6,15.8,11.6,17.3 c2.6,0.5,5.4,0.3,7.9-0.6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_295-3",
    transform: "translate(31.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_109-3",
    className: "st1",
    d: "M10.8,47.7c0-1,0.1-1.9,0.3-2.9c-4.7-4.9-4.5-12.5,0.3-17.1c1.4-1.4,3.2-2.4,5.1-2.9 c-1.4-2.4-0.5-5.4,1.7-6.7c1.4-0.8,3-0.9,4.5-0.2c1.5-9.2,9.4-11.4,14.4-10.4c0.2,0,0.4,0,0.5,0C30,4.2,21.2,8.1,18.2,15.9 c-0.1,0.2-0.2,0.5-0.2,0.8c-2.5-1.1-5.4,0-6.5,2.5c-0.6,1.4-0.5,3.1,0.2,4.5c-6.5,1.8-10.3,8.4-8.4,14.9c0.5,1.9,1.5,3.7,2.9,5.2 c-1.6,8,3.6,15.8,11.6,17.3c0.8,0.1,1.5,0.2,2.4,0.3C14.5,59.1,10.8,53.7,10.8,47.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_110-3",
    className: "st2",
    d: "M74.6,72.9H49.7c3.9,0,7-2.6,7.3-6c0.8-11.7-4.1-26.1-4.1-26.1c2.2,1.6,4.1,3.6,5.7,5.8 c1,1.3,1.7,2.6,2.5,4c0,0,1.7-10.3,8-15.7c0,0-3.8,17.3-1.7,32.3C67.8,70.4,70.9,72.9,74.6,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111-3",
    className: "st3",
    d: "M60.8,72.9h-11c3.9,0,7-2.6,7.3-6c0.8-11.7-4.1-26.1-4.1-26.1c2.2,1.6,4.1,3.6,5.7,5.8 C60.3,53.9,61.7,64.4,60.8,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_112-3",
    className: "st1",
    d: "M53.3,27.8c-0.5,0-1-0.4-1-1l0,0c0-4,3.2-7.3,7.3-7.3c0.5,0,1,0.4,1,1.1c0,0.5-0.4,1-1,1 c-2.9,0-5.2,2.4-5.2,5.2C54.3,27.4,53.8,27.8,53.3,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_113-3",
    className: "st1",
    d: "M74.5,25.6c-0.5,0-1-0.4-1-1l0,0c0-2.9-2.4-5.2-5.2-5.2c-2.9,0-5.2,2.4-5.2,5.2 c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1c0-4,3.2-7.3,7.3-7.3c4,0,7.3,3.2,7.3,7.3C75.6,25.1,75.1,25.6,74.5,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_114-3",
    className: "st4",
    d: "M79.7,73.9h-34c-0.5,0-1-0.4-1-1.1c0-0.5,0.4-1,1-1h34c0.5,0,1,0.4,1,1 C80.8,73.4,80.4,73.9,79.7,73.9L79.7,73.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAreaVerde03);
export default __webpack_public_path__ + "static/media/icon-area-verde-03.71b4951517afd87b576e882b44add778.svg";
export { ForwardRef as ReactComponent };